<template>
  <v-card
    outlined
    rounded="lg"
    class="pa-5"
  >
    <div class="d-flex justify-space-between align-center text-subtitle-2">
      <p class="text--secondary">Net Worth</p>
      <p class="font-weight-medium">{{asMoney(affordabilityResults.networth)}}</p>
    </div>
    <div class="d-flex justify-space-between align-center text-subtitle-2">
      <p class="text--secondary">Net Ratio</p>
      <p class="font-weight-medium">{{asPercent(affordabilityResults.netRatio)}}</p>
    </div>
    <div class="d-flex justify-space-between align-center text-subtitle-2">
      <p class="text--secondary">Status</p>
      <v-chip
        label
        small
        :color="affordabilityResults.netRatingColor"
      >{{affordabilityResults.netRating}}</v-chip>
    </div>
  </v-card>
</template>

<script>
export default {

  props: {
    affordabilityResults: {
      type: Object,
      default: () =>({
        networth: 0,
        netRatio: 0,
        netRating: 0,
        netRatingColor: '',
      })
    } 
  },
};
</script>
